<template>
	<div
		class="modal"
		data-backdrop="static"
		id="associateAutomation"
		role="dialog"
		tabindex="-1"
		aria-labelledby="addCampaignGroup"
		aria-hidden="true"
	>
		<div class="modal-dialog modal-xl associate-guardrail" role="document" id = "scope-body">
			<div class="modal-content campaign-g-addedit" style = "min-height:200px">
			<div v-if="showLoader" class="spinner-border" style="margin:auto;display:block;"></div>
			<div v-else>
				<div class="modal-header">
				<h5 class="modal-title" id="exampleModalLongTitle">Scope</h5>
				<button type="button" @click="reset();toggleModal()" class="close" data-dismiss="modal">
					<span aria-hidden="true">&times;</span>
				</button>
				</div>
				<div class="modal-body main_form_block">
					<div>
						<div class="form-container" style="width:1000px;">
						<form v-on:submit.prevent></form>
						</div>
						<div class ="row" style = "padding-bottom:20px;padding-top:20px;border-bottom:1px #e8e8e8 solid" v-if = "(scopeKeywordData.list && scopeKeywordData.list.length && isKeywordSelected) || showKewordTile">
							<div class="col-md-3">
								<label for="name" class="col-md-12 col-form-label">Keyword </label>
							</div>
							<div class="row col-md-9">
								<div class="col-md-6">
									<multiselect
										v-model="scopeKeywordData.list"
										:options="scopeKeywordOptions"
										:closeOnSelect="false"
										:multiple="true"
										:taggable="true"
										label="name"
										track-by="id"
										@tag="addKeywords($event,'fromEdit')"
										placeholder="Add Keywords"
										tag-placeholder="Add this as new Keywords"
										class="form-control multi-dropdown select_filter"
										:disabled = "isDisableKeyword"
										selectLabel = ""
										@remove="removeKeyword"
										>
									</multiselect>
								</div>
								<div class="col-md-6">
									<div v-if="isKeywordEditLoader" class="spinner-border" style=""></div>
									<button
										v-else
										style="color:white"
										id="edit"
										class="btn btn-primary"
										v-on:click="isDisableKeyword ? editKeyword(index) : saveEdittedScope(data, index, 'Keyword')"
									>{{isDisableKeyword ? 'Edit' : 'Save'}}</button>
									<div v-if="isKeywordDelLoader" class="spinner-border" style=""></div>
									<button
								        v-else
										style="color:white;background-color:red"
										id="delete"
										class="btn btn-primary"
										v-on:click="deleteScope(scopeKeywordData , index, 'Keyword')"
									>Delete</button>
									<button
										v-if = "scopeToEdit == index"
										style="color:white;background-color:red"
										id="delete"
										class="btn btn-primary"
										v-on:click="cancelScopeEdit(index)"
									>Cancel</button>
									<button v-if = "scopeList.length == 0" class="btn btn-primary" @click="addRuleToggle">Add New Rule</button>
								</div>

							</div>
						</div>


						<div v-if = "addedFileUrlList && addedFileUrlList.list && addedFileUrlList.list.length">
							<div>
								<!-- <div class = "col-md-3">
									<h4>{{'Imported Product Files'}}</h4>
								</div> -->
								<div v-for = "(item, index) in addedFileUrlList.list" class = "form-group row" style = "margin-bottom:10px" :key = "index">
									<div class = "col-md-3" style = "">
										<p style = "padding-left:20px;overflow-wrap: break-word">{{item.name}}</p>
									</div>
									<div class = "col-md-7">
										<button
											style="color:white;"
											id="delete"
											class="btn btn-primary"
											v-on:click="downloadFile(item, addedFileUrlList, index)"
										>Download</button>
										<div v-if = "replaceLoader  && index == actionIndex" class="spinner-border" ></div>
										<button
										v-else
											style="color:white"
											id="delete"
											class="btn btn-primary"
											v-on:click="replaceFile(item, addedFileUrlList, index)"
										>Replace</button>
										<div v-if = "deleteLoader && index == actionIndex" class="spinner-border" ></div>
										<button
											v-else
											style="color:white;background-color:red"
											id="delete"
											class="btn btn-primary"
											v-on:click="AddDeleteFile(item, addedFileUrlList, index, 'del')"
										>Delete</button>
									</div>
								</div>
								<!-- <div class = "form-group row">
									<label class = "col-md-4" style = "padding-left:20px"> -->
										<input
											ref = "file-input"
											style = "display:none"
											class="choose"
											type="file"
											placeholder="Import Product From csv"
											multiple="false"
											accept=".csv"
											@change="uploadProductsList"
									>
									<!-- </label>
									<div class = "col-md-6">
										<button
											style="color:white"
											id="delete"
											class="btn btn-primary"
											v-on:click="AddDeleteFile({}, addedFileUrlList, '', 'add')"
										>Add New File</button>
									</div>
								</div> -->

							</div>
						</div>

						<div class ="row" style = "padding-bottom:20px;padding-top:20px;border-bottom:1px #e8e8e8 solid" v-if = "(scopeAsinDataList.list)">
							<div class="col-md-3">
								<label for="name" class="col-md-12 col-form-label">Input Asin</label>
							</div>
							<div class="row col-md-9">
								<div class="col-md-6">
									<multiselect
										v-model="scopeAsinDataList.list"
										:options="scopeAsinOptions"
										:multiple="true"
										:taggable="true"
										label="asin"
										track-by="id"
										@tag="addAsin($event,'fromEdit')"
										placeholder="Add Asins"
										tag-placeholder="Add this as new Asin"
										class="form-control multi-dropdown select_filter"
										@remove="removeAsin"
										selectLabel = ""
										:disabled = "isDisabledAsin"
										deselectLabel = ""
										>
									</multiselect>
								</div>
								<div class="col-md-6">
									<div v-if="isAsinEditLoader" class="spinner-border" style=""></div>
									<button
										v-else
										style="color:white"
										id="edit"
										class="btn btn-primary"
										v-on:click="isDisabledAsin ? editAsin(index) : saveEdittedScope(data, index, 'Asin')"
									>{{isDisabledAsin ? 'Edit' : 'Save'}}</button>

									<div v-if="asinDelLoader" class="spinner-border" style=""></div>
									<button
										v-else
										style="color:white;background-color:red"
										id="delete"
										class="btn btn-primary"
										v-on:click="deleteAsin(scopeAsinDataList , index, 'Asin')"
									>Delete</button>
									<button
										v-if = "scopeToEdit == index"
										style="color:white;background-color:red"
										id="delete"
										class="btn btn-primary"
										v-on:click="cancelScopeEdit(index)"
									>Cancel</button>
									<button v-if = "scopeList.length == 0 && !isAfterEdit && isShowAddRule" class="btn btn-primary" @click="addRuleToggle">Add New Rule</button>
								</div>

							</div>
						</div>
						<div v-if="isAllSelected" class ="row">
							<div style = "text-align:right;padding-top:10px" class = "col-md-5">All Selected</div>
							<div v-if="delAllLoader" class="spinner-border" style=""></div>
							<div v-else class = "col-md-6">
								<button
									style="color:white;background-color:red"
									id="delete"
									class="btn btn-primary"
									v-on:click = "removeAllOption()"
								>Delete</button>
							</div>
						</div>
						<div v-else>
							<div v-for = "(data, index) in scopeList" >
								<div class ="row" style = "padding-bottom:20px;padding-top:20px;border-bottom:1px #e8e8e8 solid" v-if = "scopeList[index].list">
									<div class="col-md-3">
										<label for="name" class="col-md-12 col-form-label">{{data.label}} </label>
									</div>
									<div class="row col-md-9" :key = "index">
										<div class = "col-md-6">
											<multiselect
												v-model="scopeList[index].list"
												:options="showScopeOptions"
												:options-limit="300"
												:show-no-results="true"
												:max-height="600"
												:loading="currentSelected == index && isLoading ? true : false"
												:multiple="true"
												:searchable="true"
												:closeOnSelect="false"
												ref="multiselect"
												:label="scopeList[index].label == 'Product' ? 'product_title' : 'name'"
												:track-by="scopeList[index].label == 'Campaign' ? 'campaign_id' : scopeList[index].label == 'Product' ? 'asin' : 'id'"
												open-direction="bottom"
												:taggable="false"
												placeholder="Search..."
												class="form-control multi-dropdown select_filter"
												@search-change="searchFromDb($event,data,index)"
												:disabled = "scopeToEdit == index ? false : true"
												selectLabel = ""
												selectedLabel = ""
												>
												<template
													slot="noResult"
												>
													<div>Oops! No Element Found</div>
												</template>

											</multiselect>
										</div>
										<div class = "col-md-6">
											<div v-if="showEditLoader && (scopeToEdit == index) " class="spinner-border" style=""></div>
											<button
													v-else
													style="color:white"
													id="edit"
													class="btn btn-primary"
													v-on:click="scopeToEdit == index  ? saveEdittedScope(data, index, data.label) :  editScope(index)"
											>{{scopeToEdit == index ? 'Save' : 'Edit'}}</button>
											<div v-if="showDelLoader && (index == toDelIndex)" class="spinner-border" style=""></div>
											<button
												v-else
												style="color:white;background-color:red"
												id="delete"
												class="btn btn-primary"
												v-on:click="data.label == 'Product' ? deleteAsin(data, index, 'Product') : deleteScope(data, index, data.label)"
											>Delete</button>
											<button
												v-if = "scopeToEdit == index"
												style=""
												id="delete"
												class="btn btn-primary"
												v-on:click="cancelScopeEdit(index)"
											>Cancel</button>
											<button v-if = "isShowAddRule && (index == (scopeList.length - 1)) && selectScope.length" class="btn btn-primary" @click="addRuleToggle">Add New Rule</button>
											<!-- <div v-if = "data.label == 'Product'" style = "margin-top:10px">
												<div v-if = "uploadCSVProductLoader" class="spinner-border" ></div>
												<div v-else>
													<label v-show = "!fileUploadedName" class = "col-md-7" >
														<input
															class="choose"
															type="file"
															placeholder="Import Product From csv"
															multiple="false"
															accept=".csv"
															@change="uploadProductsList"
														>
													</label>
													<div v-show="fileUploadedName">
														<label style="margin-left:20px;margin-top:4px">
															{{fileUploadedName}}
															<i
																style="margin-left:20px"
																class="fa fa-times"
																@click="resetFile()"
															></i>
														</label>
													</div>
												</div>
											</div> -->
										</div>
									</div>
								</div>
							</div>
						</div>

						<button v-if = "(scopeList.length == 0 && isShowAddRule && !isAllSelected && (scopeKeywordData.list && scopeKeywordData.list.length == 0 || scopeKeywordData.length == 0) && ((addedFileUrlList && addedFileUrlList.list && addedFileUrlList.list.length == 0) || (addedFileUrlList && addedFileUrlList.length == 0 && ! addedFileUrlList.list)) && (!isAfterEdit) && (!scopeAsinDataList || scopeAsinDataList.length == 0 || (scopeAsinDataList && scopeAsinDataList.list && scopeAsinDataList.list.length == 0)))" class="btn btn-primary" @click="addRuleToggle">Add New Rule</button>


						<div v-if = "((!isShowAddRule && !isAllSelected && isDisabledAsin) || (isAfterEdit))" style = "padding-top:20px;padding-bottom:20px">
							<div class ="form-group row ">
									<div class="col-md-3">
										<label for="name" class="col-md-12 col-form-label">{{'Apply to all '+ target +'s in Profile' }}</label>
									</div>
									<div class="col-md-4">
										<multiselect
										    class="form-control multi-dropdown select_filter"
											v-if="showDropdown"
											v-model="modalValue"
											label="name"
											:options="selectScope"
											@input="selectScopeInput"
											@select = "removeIfOldData"
											@remove = "removeSelected"
											track-by="id"
											ref="multiselect"
											:multiple="false"
											:taggable="false"
											placeholder="Define scope for the rule"
											deselectLabel=""
											selectedLabel=""
											selectLabel=""
										/>
									</div>

									<div v-if="saveNewScopeLoader && scope == 'all'" class="spinner-border" ></div>
									<div style="" class = "col-sm-3">
										<button
											v-if="scope == 'all' && !saveNewScopeLoader"
											style="color:white; align-self:center"
											class="btn btn-primary"
											v-on:click="saveNewScope()"
										>Save</button>
									</div>

							</div>



							<div class="form-group row" v-if="(scope != 'all' && scope != 'Import File' )">
								<div class="col-md-3"></div>
								<div class="col-md-4" style = "margin-right:10px">
									<multiselect
										v-model="scopeData"
										v-if="defineScope"
										:options="showScopeOptions"
										:options-limit="300"
										:show-no-results="true"
										:max-height="600"
										:loading="isLoadingInFirstSearch && !isLoading"
										:multiple="true"
										:searchable="true"
										:closeOnSelect="false"
										ref="multiselect"
										:label="scope == 'Product' ? 'product_title' : 'name'"
										:track-by="scope == 'Campaign' ? 'campaign_id' : scope == 'Product' ? 'asin' : 'id'"
										open-direction="bottom"
										:taggable="false"
										placeholder="Search..."
										class="form-control multi-dropdown select_filter"
									    @search-change="searchFromDb($event,'','','fromAdd')"
										:selectLabel = "'Add '+ scope "
										:deselectLabel = "'Remove '+ scope "
										selectedLabel = ""

									>
									<!-- <template slot="tag" slot-scope="{ option, remove }">
										<span class="custom__tag">
										<span>{{ option.name }}</span>
										<span class="custom__remove" @click="remove(option)">X</span>
										</span>
									</template> -->
									<template slot="clear" slot-scope="props">
										<div
											class="multiselect__clear"
											v-if="scopeData.length"
											@mousedown.prevent.stop="clearAll(props.search)"
										></div>
									</template>
									<template
										slot="noOptions"
									>
										<div>Try making a search.</div>
									</template>
									<template
										slot="noResult"
									>
										<div>Oops! No element found</div>
									</template>
									</multiselect>
									<multiselect
										v-model="scopeKeywordDataList"
										v-if="defineKeywordScope"
										:options="scopeKeywordOptions"
										:multiple="true"
										:taggable="true"
										label="name"
										track-by="id"
										@tag="addKeywords($event,'fromAdd')"
										placeholder="Add Keywords"
										tag-placeholder="Add this as new Keywords"
										class="form-control multi-dropdown select_filter"
										selectLabel = ""
										deselectLabel = ""
									>
									</multiselect>
									<multiselect
										v-model="scopeAsinData"
										v-if="defineAsinScope"
										:options="scopeAsinOptions"
										:multiple="true"
										:taggable="true"
										label="asin"
										track-by="id"
										@tag="addAsin($event,'fromAdd')"
										placeholder="Add Asins"
										tag-placeholder="Add this as new Asin"
										class="form-control multi-dropdown select_filter"
										selectLabel = ""
										deselectLabel = ""
										>
									</multiselect>
								</div>
								<div v-if="saveNewScopeLoader" class="spinner-border" style=""></div>
								<div>
									<button
										v-if="(defineScope || defineKeywordScope || defineAsinScope) && !saveNewScopeLoader"
										style="color:white"
										class="btn btn-primary"
										v-on:click="CancelNewScope()"
									>Cancel</button>
									<button
										v-if="(defineScope || defineKeywordScope || defineAsinScope) && !saveNewScopeLoader"
										style="color:white"
										class="btn btn-primary"
										v-on:click="saveNewScope()"
									>Save</button>
								</div>
							</div>

							<div class = "form-group row" v-if = "scope == 'Import File'">
								<div class = "col-md-3"></div>
								<div v-show="selectedFileUrlList.length && ( addedFileUrlList && addedFileUrlList.list && addedFileUrlList.list.length ?  (selectedFileUrlList.length != addedFileUrlList.list.length): true)" class = "form-group row">
									<div class = "col-md-1"></div>
									<div class = "col-md-8" style = "display:inline-table;background:#3da3a7;margin-top: 5px;color:white;border-radius:5px;padding:0px;text-align:center">
										<label  style="padding:0px;margin:0px" v-for = "(item,index) in selectedFileUrlList">
											<div v-if = "((selectedFileUrlList.length-1) == index)" style = "padding:5px;margin:0px">
												{{item.name}}
												<i
													style=""
													class="fa fa-times"
													@click="resetFile(index)"
												></i>
											</div>
											<div v-else style = "padding:0px;margin:0px"></div>
										</label>
									</div>
									<div class = "col-md-2">
										<div v-if = "newFileSavedToDB" class="spinner-border" ></div>
										<button
										v-else
											style="color:white"
											class="btn btn-primary"
											v-on:click="saveFileScope()"
										>Save</button>
									</div>
								</div>
								<div v-if = "uploadCSVProductLoader" class="spinner-border" ></div>
								<div v-else class = "col-md-12">
									<div class = "form-group row">
										<div class = "col-md-3"></div>
										<a style = "display:flex;align-items:center;padding-left:15px" href="sampleAsin.csv" id="file_download_asin" download>Download Sample Asin CSV</a>
										<br>
										<label class = "col-md-4">
											<input
												class="choose"
												type="file"
												placeholder="Import Product From csv"
												multiple="false"
												accept=".csv"
												@change="uploadProductsList"
										>
										</label>
									</div>
								</div>
							</div>
						</div>

					</div>
				</div>
				<div class="modal-footer" style = "border:0px">
				<!-- <button type="button" class="btn btn-secondary" v-on:click="cancel">Cancel</button> -->
				<button class="btn btn-primary" @click="toggleModal();reset();" data-dismiss="modal" id="submit">Done</button>
				</div>
			</div>
			</div>
		</div>
	</div>
</template>


<script>
import Multiselect from "vue-multiselect";
import CampaignFormDropDown from "@/components/add-campaign/CampaignFormDropDownNew";
import ReusableComponent from "./ReusableComponent.vue";
export default {
	name: "associateAutomation",
	components: {
		CampaignFormDropDown,
		Multiselect,
		ReusableComponent
	},
	props: ["automationId","target","automationIndex"],
	mounted() {
		this.showDropdown = false;
		this.showDropdown = true;
		this.initialiseAutomationPopup();
	},
	watch: {},
	data() {
		return {
			selectScopeValues: [
				{ id: "all", name: "All", label: "All" },
				{ id: "Vendor", name: "Select Vendor", label: "Vendor"  },
				{ id: "Profile", name: "Select Brand Profile", label: "Brand"},
				{ id: "CampaignGroup", name: "Select Campaign Group", label: "Campaign Group"},
				{ id: "Campaign", name: "Select Campaign", label: "Campaign"},
				{ id: "Keyword", name: "Select Keyword", label: "Keyword" },
				{ id: "Product", name: "Select Product", label: "Product" },
				{ id: "Import File", name: "Import CSV File", label: "Import CSV File"},
				{ id: "Enter Asin", name: "Enter Asin", label: "Enter Asin"}

			],
			scope: "",
			scopeData: [],
			selectScope:[],
			showScopeOptions: [],
			scopeKeywordData: [],
			scopeKeywordDataList:[],
			scopeKeywordOptions: [],
			defineKeywordScope: false,
			defineScope: false,
			showDropdown: true,
			isLoading: false,
			scopeTrackerId: 'id',
			scopeList:[],
			showLoader:false,
			isKeywordSelected:false,
			isShowAddRule:false,
			currentSelected:-1,
			isLoadingInFirstSearch:false,
			scopeToEdit:-1,
			isDisableKeyword:true,
			showEditLoader:false,
			showDelLoader:false,
			isKeywordEditLoader:false,
			isKeywordDelLoader:false,
			saveNewScopeLoader:false,
			toDelIndex: -1,
			isAllSelected:false,
			allScopeId:-1,
			delAllLoader:false,
			scopeListCopy:[],
			modalValue:null,
			showKewordTile:false,
			uploadCSVProductLoader: false,
			fileUploadedName:[],
			showExportFileData: false,
			selectedFileUrlList: [],
			addedFileUrlList: [],
			isReplaceFile: -1,
			replaceLoader: false,
			deleteLoader: false,
			actionIndex: -1,
			isAfterEdit: false,
			newFileSavedToDB: false,
			scopeAsinDataList: [],
			defineAsinScope: false,
			scopeAsinOptions:[],
			isDisabledAsin:true,
			isAsinEditLoader:false,
			asinDelLoader:false,
			scopeAsinData:[]
		};
	},

	methods: {
		getAllAutomationsList() {
			this.$store.dispatch("automation/getAutomations");
		},
		resetScopeListForProduct(){
			this.selectScope = [{ id: "Import File", name: "Import CSV File", label: "Import CSV File"}]
			this.isAllSelected = true
			this.isAfterEdit = true;
		},
		editKeyword(){
			this.isDisableKeyword = false
		},

		editAsin(){
			this.isDisabledAsin = false
		},
		reset() {
			this.scopeKeywordData = [];
			this.scopeData = []
			this.defineScope = false
			this.defineKeywordScope = false
		//	this.scopeData = []
			this.showScopeOptions = []
			//this.scopeKeywordData = []
			this.scopeKeywordOptions = []
		//	this.scope = ''
			this.scopeTrackerId = 'id'

		},
		toggleModal() {

			this.$emit("toggleModal");
		},
		addRuleToggle(){
			var elmnt = document.getElementById("scope-body");
			elmnt.scrollIntoView(false);


			this.isShowAddRule = false
		},
		CancelNewScope(){
			
			this.isShowAddRule = true;
			this.scope = '';
			//this.scopeKeywordData = [];
			this.scopeData = [];
			this.modalValue = null;
			this.scopeAsinData = [];
			this.isAfterEdit = false
		},
		cancelScopeEdit(index){
			
			console.log(this.scopeList[index].list);
			console.log(this.scopeListCopy[index].list);
			this.scopeList[index].list = this.scopeListCopy[index].list
			this.scopeToEdit = -1;
			this.scopeAsinData = [];
		},
		initialiseAutomationPopup() {
			var payload = {
				id: this.automationId
			}

			let vm = this;

			if(this.target==="Campaign"){
				this.selectScope=this.selectScopeValues.slice(0,5)
			}
			else if(this.target==="Keyword"){
					this.selectScope=this.selectScopeValues.slice(0,6)
			}
			else if(this.target==="Brand Profile"){
					this.selectScope=this.selectScopeValues.slice(0,3)
			}
			else if(this.target==="Campaign Group"){
				this.selectScope=this.selectScopeValues.slice(0,4)
			}
			else if(this.target==="Product"){
				this.selectScopeValues.splice(1,5)
				this.selectScope = this.selectScopeValues
			}


			this.showLoader = true
			this.$store.dispatch("automation/showScopeData",payload).then(res => {
				vm.showLoader = false
				let scopedValues = [...res];
				let scopeTempList = []
				if(res.length){
					vm.isShowAddRule = true
					vm.selectScope.map((resp, index) => {
						let typeList = []
						typeList = scopedValues.filter((labelVales) => {
							return labelVales.automation_scope == resp.id
						})
						if(typeList && typeList.length){
							scopeTempList.push({label : resp.label, list : typeList, tag : resp.id});
						}
					})
				}

				if(scopeTempList && scopeTempList.length && scopeTempList[0].tag == "all"){
					vm.isAllSelected = true;
					vm.allScopeId = scopeTempList[0].list[0].id
				}

				let isExportFile = -1;
				let allForProductSelected = false

				let objIfAsin = false;
				let objIfAsinData = {};

				let isRemoveNoProduct = -1;


				scopeTempList.map((e, index )=> {
					if(e.tag == "Import File" && e.list[0].file_ref!= "[]"){
						isExportFile = index;
					}
					if(e.tag == 'all' && e.list && e.list.length && e.list[0].target == 'Product'){
						allForProductSelected = true
					}
					if(e.tag == "Product"){
					  let parseData = JSON.parse(e.list[0].scope_values)
					  let addedAsin = parseData.filter((option, index) => {
						  return (option.type == "add asin")
					  })
						if(addedAsin.length){
						//	vm.defineAsinScope = true
							let dataListOptions = JSON.parse(JSON.stringify(e.list))
							dataListOptions[0].scope_values = JSON.stringify(addedAsin)
							objIfAsin = true
							objIfAsinData = {label : 'Enter Asin', list : dataListOptions, tag : 'Enter Asin'}
							let tList = parseData.filter((vals) => {
								return(vals.type != "add asin")
							 })
							 if(!tList.length || tList.length == 0){
								isRemoveNoProduct = scopeTempList.findIndex(id => id.tag == 'Product')
							 }
							 else{
								 scopeTempList[index].list[0].scope_values = JSON.stringify(tList)
							 }
						}
					}
				})


				if(isExportFile!=-1){

					if(!scopeTempList[isExportFile].tag == 'Import File'){
						isExportFile = scopeTempList.map(e => e.tag == 'Import File')
					}

					let data = JSON.parse(scopeTempList[isExportFile].list[0].file_ref)
					vm.addedFileUrlList.list = JSON.parse(JSON.stringify(data))
					vm.selectedFileUrlList = JSON.parse(JSON.stringify(data))
					vm.addedFileUrlList.automationId = scopeTempList[isExportFile].list[0].automation_id;
					vm.addedFileUrlList.id = scopeTempList[isExportFile].list[0].id;
					vm.isAfterEdit = true
					scopeTempList.splice(isExportFile, 1)
				}

					if(isRemoveNoProduct!=-1){
						scopeTempList.splice(isRemoveNoProduct, 1)
					}

					if(objIfAsin){
						scopeTempList.push(objIfAsinData)
					}

					if(!allForProductSelected){
						if(scopeTempList && scopeTempList.length){
							scopeTempList.map((typeList) => {
								let arr = []

								typeList.list.map((data) => {
									JSON.parse(data.scope_values).map((multipleScopeDefined) => {
										arr.push(multipleScopeDefined)
									})
								})
								if(typeList.tag != "Keyword" && typeList.tag != "Enter Asin"){
									vm.scopeList.push({label:typeList.label, list: arr, tag: typeList.tag, id:typeList.list[0].id})

								}
								else if(typeList.tag == "Enter Asin"){
									vm.scopeAsinDataList.label = 'Enter Asin';
									vm.scopeAsinDataList.tag = 'Enter Asin';
									vm.scopeAsinDataList.id = typeList.list[0].id;
									vm.isDisabledAsin = true
									vm.defineAsinScope = false
									let list = []
									arr.map((res) => {
										list.push(res)
									})
									vm.scopeAsinDataList.list = list
								}
								else{
									vm.scopeKeywordData.tag = 'Keyword';
									vm.scopeKeywordData.label = 'Keyword';
									vm.scopeKeywordData.id = typeList.list[0].id;
									let list = []
									arr.map((res) => {
										list.push(res)
									})
									vm.scopeKeywordData.list = list
								}
							//	vm.scopeData.push({list:arr, tag: typeList.tag})
								vm.selectScope.filter((selectedScopes, index) => {
									return typeList.label == selectedScopes.label ? vm.selectScope.splice(index, 1) : null
								})
								console.log(vm.selectScope);
							})
						}

						if((vm.scopeList && vm.scopeList.length) || (vm.scopeKeywordData && vm.scopeKeywordData.list && vm.scopeKeywordData.list.length) || (vm.scopeAsinDataList && vm.scopeAsinDataList.list.length)){
							vm.selectScope.filter((val,index) => {
								return val.id == "all" ? vm.selectScope.splice(index,1) : null
							})

						}

						let checkKeyword = vm.selectScope.filter((val) => {
							return val.id == "Keyword"
						})

						if(checkKeyword && checkKeyword.length){
							vm.isKeywordSelected = false
						}
						else{
							vm.isKeywordSelected = true
							if(vm.scopeKeywordData && vm.scopeKeywordData.list){
								vm.scopeKeywordOptions = JSON.parse(JSON.stringify(vm.scopeKeywordData.list))
							}
						}


					vm.scopeListCopy = JSON.parse(JSON.stringify(vm.scopeList))
					}
					else{
						vm.selectScope = [{ id: "Import File", name: "Import CSV File", label: "Import CSV File"}]
						vm.isAfterEdit = true
					}


			});
		},
		editScope(id){
		  this.scopeToEdit = id
		},
		removeSelected(){
			this.modalValue = null;
			this.scope = '';
			this.scopeData = [];
			this.isLoadingInFirstSearch = false;
			this.showScopeOptions = [];
			this.scopeAsinData = [];
		//	this.scopeAsinDataList = [];

		},
		removeIfOldData(){
			this.scope = '';
			this.scopeData = [];
		},
		removeAllOption(type){
			
			let payload = {
				id:this.allScopeId,
				type:"scope"
			}
			let vm = this;
			let typeToDel = "all"
			if(type == 'FromProdDel'){
				typeToDel = "Import file"
			}
			else{
				this.delAllLoader = true

			}
			this.$store.dispatch('automation/DelAction',payload).then((res) => {
				vm.$emit("deleteScopeUpdation",typeToDel, vm.automationIndex)
				if(type == 'FromProdDel'){

				}
				else{
					vm.delAllLoader = false
					vm.isAllSelected = false;
				}

				vm.deleteLoader = false;
				vm.replaceLoader = false;
				if(!vm.selectedFileUrlList.length){
					vm.addedFileUrlList.list = [];
					vm.selectedFileUrlList = [];
				}
				if(vm.target == "Product"){
					vm.isAfterEdit = true;
					if(vm.scopeList.length || vm.scopeAsinDataList && vm.scopeAsinDataList.list && vm.scopeAsinDataList.list.length){

						if(!vm.scopeAsinDataList || (vm.scopeAsinDataList && !vm.scopeAsinDataList.list)){
							let isAsin = vm.selectScope.filter(e=> e.id == 'Enter Asin')
							if(isAsin.length == 0){
								vm.selectScope.push(
									{ id: "Enter Asin", name: "Enter Asin", label: "Enter Asin"})
							}
						}
						if(!vm.scopeList.length){
							let isproduct = vm.selectScope.filter(e=> e.id == 'Product')
							if(isproduct.length == 0){
								vm.selectScope.push(
									{ id: "Product", name: "Select Product", label: "Product" })
							}
						}
					}
					else{
						if(vm.selectScope.length!=4 && !vm.isAllSelected){
							vm.selectScope.push(
								{ id: "Product", name: "Select Product", label: "Product" },
								{ id: "Enter Asin", name: "Enter Asin", label: "Enter Asin"}
								)
							vm.selectScope.unshift({ id: "all", name: "All", label: "All" })
						}
					  }
					}
					else{
						vm.allScopeId = '';
						vm.scope = ''
						if(vm.scopeList && vm.scopeList.length){
							if(vm.scopeList.length == 1 && vm.scopeList[0].label == "All"){
								vm.scopeList = []
								vm.selectScope.unshift({
									 id: "all", name: "All", label: "All"
								})
							}

						}
					}


			})
		},
		removeTag(option, data, index){
			console.log(option);
			// let scopeIndex = this.scopeList[index].list.findIndex((res) => JSON.stringify(res)==JSON.stringify(option))
			// this.scopeList[index].list.splice(scopeIndex, 1)
		},
		removeAsin(option, id){
			
			if(this.scopeAsinDataList && this.scopeAsinDataList.list && this.scopeAsinDataList.list.length){
				let editAsinRemove = this.scopeAsinDataList.list.findIndex((res) =>  JSON.stringify(res)==JSON.stringify(option))
				let tempData = JSON.parse(JSON.stringify(this.scopeAsinDataList.list))
				tempData.splice(editAsinRemove, 1)
				this.scopeAsinDataList.list = tempData
				this.scopeAsinDataList.splice(0,0)
				//this.scopeAsinDataList = JSON.parse(JSON.stringify(this.scopeAsinDataList))

				if(this.scopeAsinOptions.length){
					let data = this.scopeAsinOptions.findIndex((res) =>  JSON.stringify(res)==JSON.stringify(option))
					if(data!=-1){
						let dataOptions = JSON.parse(JSON.stringify(this.scopeAsinOptions))
						dataOptions.splice(data,1)
						this.scopeAsinOptions = JSON.parse(JSON.stringify(dataOptions))
					}
				}
			}
			else if(this.scopeAsinData){
				let addAsinRemove = this.scopeAsinData.findIndex((res) =>  JSON.stringify(res)==JSON.stringify(option))
				this.scopeAsinData.splice(addAsinRemove, 1)
			}
			console.log(this.scopeAsinDataList);
			console.log(this.scopeAsinDataList.list[0]);
		},
		removeKeyword(option, id){


		//	let dataIndex = this.scopeKeywordData.list.findIndex((res) =>  res==option)
			let optionIndex = this.scopeKeywordOptions.findIndex((res) =>  JSON.stringify(res)==JSON.stringify(option))
			//this.scopeKeywordData.list.splice(dataIndex,1)
			this.scopeKeywordOptions.splice(optionIndex,1)
			if(this.scopeKeywordOptions && this.scopeKeywordOptions == 0 && this.isKeywordSelected){
				this.showKewordTile = true
			}
			else{
				this.showKewordTile = false
			}
		},
		deleteAsin(data, index, type){
			let toSendList = [];
			if(type == "Asin"){
				let isProductListData = this.scopeList.filter((e) => e.label == 'Product')
				if((isProductListData && isProductListData.list && isProductListData.list.length) || (isProductListData && isProductListData.length && isProductListData[0].list && isProductListData[0].list.length) ){
					toSendList = isProductListData && isProductListData.list || isProductListData && isProductListData[0].list
					let payload = {
						id:this.scopeAsinDataList.id,
						selectedOptions: toSendList,
						selectedKeywords: [],
						selectedType : 'Product',
						automationId :  this.automationId,
						target: this.target,
						file_ref: null
					}
					this.asinDelLoader = true;
					let vm = this;
					this.$store.dispatch("automation/addUpdateGuardRail", payload).then(response => {
						if(response){
							vm.asinDelLoader = false
							vm.scopeAsinDataList.list = [];
							vm.scopeAsinDataList = [];
							vm.defineAsinScope = false;
							vm.scopeAsinOptions = [];
							vm.selectScope.push({ id: "Enter Asin", name: "Enter Asin", label: "Enter Asin"})
							this.$emit("saveScope",payload, this.automationIndex )

						}
					})
				}
				else{
					this.deleteScope(this.scopeAsinDataList, '', 'Asin', 'AsinEdit')
				}
			}
			else if(type == 'Product'){
				if((this.scopeAsinDataList && this.scopeAsinDataList.list && this.scopeAsinDataList.list.length) || this.scopeAsinDataList && this.scopeAsinDataList.length ){
					toSendList = this.scopeAsinDataList && this.scopeAsinDataList.list || this.scopeAsinDataList;
					let payload = {
						id:this.scopeAsinDataList.id,
						selectedOptions: toSendList,
						selectedKeywords: [],
						selectedType : 'Product',
						automationId :  this.automationId,
						target: this.target,
						file_ref: null
					}
					this.showDelLoader = true;
					let vm = this;
					this.$store.dispatch("automation/addUpdateGuardRail", payload).then(response => {
						if(response){
							vm.showDelLoader = false;
							vm.scopeList.splice(index, 1)
							vm.selectScope.push({ id: "Product", name: "Select Product", label: "Product" })
							this.$emit("saveScope",payload, this.automationIndex )
						}
					})
				}
				else{
					this.deleteScope(data, index, type)
				}
			}

		},
		deleteScope(data, index, type, callie){
			this.toDelIndex = index
			let payload = {}
				payload = {
					id:data.id,
					type:"scope"
				}

				if(type == 'Keyword'){
					this.isKeywordDelLoader = true
				}
				else if(type == "Asin"){
					this.asinDelLoader = true
				}
				else if(callie == "removeAllKeyword"){
					this.isKeywordEditLoader = true;
				}
				else if(callie == "FromEdit"){
					this.showEditLoader = true
				}
				else{
					this.showDelLoader = true
				}

			let vm  = this;
			this.$store.dispatch('automation/DelAction',payload).then((res) => {
				vm.$emit("deleteScopeUpdation",data, vm.automationIndex)
				vm.modalValue = null
				if(callie == "FromEdit"){
					vm.showEditLoader = false
					vm.scopeToEdit = -1;
					vm.scopeList.splice(index,1)
					vm.showDelLoader = false
				}
				else if(callie == "removeAllKeyword"){
					vm.scopeKeywordData = [];
					this.isKeywordEditLoader = false;
					this.showKewordTile = false;
				}
				else if(type == 'Keyword'){
					vm.scopeKeywordData = [];
					vm.isKeywordDelLoader = false;
				}
				else if(type == "Asin"){
					this.asinDelLoader = false;
					vm.scopeAsinDataList.list = [];
					vm.scopeAsinDataList = [];
					vm.defineAsinScope = false;
					vm.scopeAsinOptions = [];
				}
				else{
					vm.scopeList.splice(index,1)
					vm.showDelLoader = false
				}
				vm.isShowAddRule = true
				if(vm.scopeList.length == 0){
					vm.selectScope.unshift({
						id: 'all',
						name: 'All',
						label: 'All'
					})
				}

				

				if(data && data.label!='All'){
					let name = 'Select '+ data.label;
					vm.selectScope.push({
						id: data.tag,
						name: name,
						label: data.label
					})
				}

			})
		},
		saveEdittedScope(data, index, type){
			let payload = {}
			if(( data && data.list && data.list.length) || (type == "Keyword" && this.scopeKeywordData.list.length) || (type == "Asin" && this.scopeAsinDataList.list.length)){
				if(type == 'Keyword'){
					this.isKeywordEditLoader = true
					payload = {
						id:this.scopeKeywordData.id,
						selectedOptions: [],
						selectedKeywords: this.scopeKeywordData.list,
						selectedType : 'Keyword',
						automationId :  this.automationId,
						target: this.target,
						file_ref: null
					}
				}
				else if(type == 'Asin'){
					this.isAsinEditLoader = true;
					let toSendList = [];
					let isProductListData = this.scopeList.filter((e) => e.label == 'Product')
					if(isProductListData && isProductListData.list && isProductListData.list.length){
						toSendList = this.scopeAsinDataList.list.concat(isProductListData.list)
					}
					else if(isProductListData && isProductListData.length && isProductListData[0].list && isProductListData[0].list.length){
						toSendList = this.scopeAsinDataList.list.concat(isProductListData[0].list)
					}
					else{
						toSendList = this.scopeAsinDataList.list
					}
					payload = {
						id:this.scopeAsinDataList.id,
						selectedOptions: toSendList,
						selectedKeywords: [],
						selectedType : 'Product',
						automationId :  this.automationId,
						target: this.target,
						file_ref: null
					}
				}
				else if(type == "Product"){

					let toSendList = [];
					if(this.scopeAsinDataList && this.scopeAsinDataList.list && this.scopeAsinDataList.list.length){
						toSendList = this.scopeAsinDataList.list.concat(data.list)
					}
					else{
						toSendList = data.list
					}

					payload = {
						id:data.id,
						selectedOptions: toSendList,
						selectedKeywords: [],
						selectedType : 'Product',
						automationId :  this.automationId,
						target: this.target,
						file_ref: null
					}
					this.showEditLoader = true
				}
				else{
					this.showEditLoader = true
					payload = {
						id:data.id,
						selectedOptions: data.list,
						selectedKeywords: [],
						selectedType : data.tag,
						automationId :  this.automationId,
						target: this.target,
						file_ref: null
					}
				}

				let vm = this

				this.$store
					.dispatch("automation/addUpdateGuardRail", payload)
					.then(response => {
						if(type == 'Keyword'){
							this.showKewordTile = false
							let dataList = {
								tag:'Keyword',
								id:vm.scopeKeywordData.id,
								list:vm.scopeKeywordData.list
							}
							this.$emit("editScope",dataList, vm.automationIndex)
						}
						else if(type == "Product" || type == 'Asin'){
							this.$emit("saveScope",payload, vm.automationIndex )
							// if(type == 'Asin'){
							// 	vm.scopeAsinDataList.id = response
							// }
						}
						else{
							this.$emit("editScope",data, vm.automationIndex)
						}
						vm.scopeToEdit = -1;
						vm.isDisableKeyword = true
						vm.showEditLoader = false
						vm.isKeywordEditLoader = false
						vm.isAsinEditLoader = false
						vm.isDisabledAsin = true
						//vm.getAllAutomationsList();
					//	vm.toggleModal();
					});
					vm.scopeListCopy = JSON.parse(JSON.stringify(vm.scopeList))

			}
			else{
				if(type == 'Keyword'){
					vm.deleteScope(vm.scopeKeywordData, index, data, "removeAllKeyword")
				}
				else{
					vm.deleteScope(data,index,data.tag, "FromEdit")
				}
			}


		},
		saveFileScope(){
			let payload = {
				selectedOptions: [],
				selectedKeywords: [],
				selectedType : this.scope,
				automationId :  this.automationId,
				target: this.target,
				file_ref: this.selectedFileUrlList
			}

			let vm  = this;
			if(this.addedFileUrlList && this.addedFileUrlList.id){
				payload.id = this.addedFileUrlList.id;
			}
			this.newFileSavedToDB = true
			this.$store.dispatch("automation/addUpdateGuardRail", payload).then((response) => {
			vm.addedFileUrlList.list = JSON.parse(JSON.stringify(vm.selectedFileUrlList))
			vm.addedFileUrlList.id = response;
			vm.isAfterEdit = true;
			this.scope = ""
			vm.$emit("saveScope",payload, this.automationIndex )
			vm.newFileSavedToDB = false;
		//	vm.isAfterEdit = false;
			vm.modalValue = null
			})
		},
		downloadFile(item, addedFileUrlList, index){
			this.fileDownload = true
			var link = document.createElement("a");
			link.download = item.name;
			link.href = item.downloadUrl;
			if(link){
				link.click();
			}
		},
		replaceFile(item, addedFileUrlList, index){
			this.$refs["file-input"].click();
			this.isReplaceFile = index;
		},
		AddDeleteFile(item, addedFileUrlList, index, type){
			let vm = this;
			 this.actionIndex = index


			if(type == "del"){
				this.deleteLoader = true
				this.selectedFileUrlList.splice(index, 1);
			}
			if(type == "add"){
			//	this.selectedFileUrlList = this.selectedFileUrlList
			}
			if(type == "replace"){
				this.replaceLoader = true;
				this.selectedFileUrlList.splice(index, 1, item);
			}

			if(this.selectedFileUrlList.length == 0){
				this.allScopeId = this.addedFileUrlList.id;
				this.addedFileUrlList = [];
				this.removeAllOption('FromProdDel')

			}
			else{

							let payload = {
								id: this.addedFileUrlList.id,
								selectedOptions: [],
								selectedKeywords: [],
								selectedType : "Import File",
								automationId :  this.addedFileUrlList.automationId,
								target: this.target,
								file_ref: this.selectedFileUrlList
							}
							this.$store.dispatch("automation/addUpdateGuardRail", payload).then((response) => {
									vm.isReplaceFile = -1;
									vm.actionIndex = -1

									if(type == "del"){
										vm.deleteLoader = false
									}
									else if (type == "replace"){
										vm.replaceLoader = false;
									}

									vm.$emit("saveScope",payload, this.automationIndex )

									// if(type == "del"){
									// 	vm.addedFileUrlList.list.splice(index, 1)
									// }
									// if(type == "add"){
									// 	let selectedListLength = vm.selectedFileUrlList.length -1
									// 	vm.addedFileUrlList.list.push({
									// 		uploadUrl: vm.selectedFileUrlList[selectedListLength].uploadUrl,
									// 		downloadUrl: vm.selectedFileUrlList[selectedListLength].downloadUrl,
									// 		name: vm.selectedFileUrlList[selectedListLength].name
									// 	})
									// }
									vm.addedFileUrlList.list = JSON.parse(JSON.stringify(vm.selectedFileUrlList))
							})
			}

		},
		saveNewScope(){
			if(this.scopeData.length || this.scopeKeywordDataList.length || this.scope == 'all' || this.scopeAsinData.length){
				let selectedData = [];
				let addedId = ""
				let selectedScope = "";
				if((this.scopeAsinData.length) && this.target == "Product"){
					let isProductListData = this.scopeList.filter((e) => e.label == 'Product')
					if(isProductListData && isProductListData.length && isProductListData[0].list && isProductListData[0].list.length){
						selectedData = this.scopeAsinData.concat(isProductListData[0].list)
						addedId = isProductListData[0].id
					}
					else{
						selectedData = this.scopeAsinData
					}
					selectedScope = "Product"
				}
				else if(this.scopeData.length && this.scope == "Product"){
					if(this.scopeAsinDataList && this.scopeAsinDataList.list && this.scopeAsinDataList.list.length){
						selectedData = this.scopeAsinDataList.list.concat(this.scopeData)
						selectedScope = 'Product'
						addedId = this.scopeAsinDataList.id
					}
					else{
						selectedData = this.scopeData
						selectedScope = 'Product'

					}
				}
				else {
					selectedData = this.scopeData
					selectedScope = this.scope
				}
				this.saveNewScopeLoader = true
				let payload = {
					selectedOptions: selectedData,
					selectedKeywords: this.scopeKeywordDataList,
					selectedType : selectedScope,
					automationId :  this.automationId,
					target: this.target,
					file_ref: null
				}

				if(addedId){
					payload.id = addedId
				}
				let vm = this;
				this.$store
					.dispatch("automation/addUpdateGuardRail", payload)
					.then(response => {
						this.$emit("saveScope",payload, this.automationIndex )
						this.saveNewScopeLoader = false
						this.modalValue = null
						if(vm.scope == 'all'){
							 // vm.toggleModal();
							   if(vm.target == "Product"){
								   vm.resetScopeListForProduct();
								   vm.allScopeId = response
							   }
							   else{
								   vm.reset();
								   vm.isAllSelected = true
								   vm.allScopeId = response
							   }

						}
						else{
							if(vm.scope == 'Keyword'){
								vm.scopeKeywordData.label = 'Keyword';
								vm.scopeKeywordData.tag = 'Keyword';
								vm.scopeKeywordData.id = response;
								vm.scopeKeywordData.list = this.scopeKeywordDataList;
								vm.scopeKeywordDataList = [];
								vm.showKewordTile = false


								let keywordFilterList = vm.selectScope.filter(res => res.id == 'Keyword' || res.id == 'all')
								keywordFilterList.map((res) => {
									let indexOfData = vm.selectScope.indexOf(res)
									vm.selectScope.splice(indexOfData,1)
								})

							}
							else if(vm.scope == 'Enter Asin'){
								vm.scopeAsinDataList.label = 'Enter Asin';
								vm.scopeAsinDataList.tag = 'Enter Asin';
								vm.scopeAsinDataList.id = response;
								vm.scopeAsinDataList.list = JSON.parse(JSON.stringify(vm.scopeAsinData));
								vm.scopeAsinData = [];
								vm.isDisabledAsin = true
								vm.defineAsinScope = false;
								//vm.isAfterEdit = false

								let asinFilterList = vm.selectScope.filter(res => res.id == 'Enter Asin' || res.id == 'all')
								asinFilterList.map((res) => {
									let indexOfData = vm.selectScope.indexOf(res)
									vm.selectScope.splice(indexOfData,1)
								})
							}

							else{
								let label = ''
								if(vm.scope == 'CampaignGroup'){
									label = 'Campaign Group'
								}
								else if(vm.scope == 'Profile'){
									label = 'Brand'
								}
								else{
									label = vm.scope.charAt(0).toUpperCase() + vm.scope.slice(1)
								}
								vm.scopeList.push({
									label:label,
									tag:vm.scope,
									id:response,
									list:vm.scopeData
								})

								vm.isShowAddRule = true;
								let indexList = vm.selectScope.filter(res => (res.id == vm.scope  || res.id == 'all'))
								indexList.map((res) => {
									let indexOfData = vm.selectScope.indexOf(res)
									vm.selectScope.splice(indexOfData,1)
								})

								if(vm.scope == 'Product'){
									vm.isAfterEdit = false
								}

							}

							vm.scope = '';
							vm.scopeData = [];

							vm.scopeListCopy = JSON.parse(JSON.stringify(vm.scopeList))
							if(vm.scopeKeywordData && vm.scopeKeywordData.list && vm.scopeKeywordData.list.length){
								vm.isKeywordSelected = true
								vm.isDisableKeyword = true
								vm.defineKeywordScope = false
								vm.isShowAddRule = true
							}

							//vm.selectScope.splice(index,1)

						}

					});
			}

		},
		getObjectFromId(id, list) {},
		selectScopeInput(value) {

			//this.reset();
			let optionKey = value.id
			this.scope = optionKey;
			// if (optionKey === "all") {
			// 	this.scope = optionKey;
			// } else
			if (optionKey == "Keyword") {
				this.defineKeywordScope = true;
				this.defineScope = false;
			}
			else if(optionKey == "Import File"){
				this.showExportFileData = true
			}
			else if(optionKey == "Enter Asin"){
				this.defineAsinScope = true
				this.defineScope = false;
			}
			else {
				this.defineKeywordScope = false;
				this.defineScope = true;
				this.showExportFileData = false
				this.defineAsinScope = false


			}
		},
		addKeywords(newKeyword,type) {
			const keyword = {
				name: newKeyword,
				id: newKeyword
			};
			//this.scopeKeywordOptions.push(keyword);
			let list = [];
			if(this.scopeKeywordData.list){
				list = [...this.scopeKeywordData.list]
			}
			else if(this.scopeKeywordDataList.length){
				list = [...this.scopeKeywordDataList]
			}
			list.push(keyword)

			if(type == "fromAdd"){
				this.scopeKeywordDataList = JSON.parse(JSON.stringify(list))
			}
			else{
				this.scopeKeywordData.list = list;
			}

			this.scopeKeywordOptions = JSON.parse(JSON.stringify(list));
		},
		addAsin(newAsin, type){
			
			let newAsinList = newAsin.split(',');

			let list = [];
			if(this.scopeAsinDataList && this.scopeAsinDataList.list && this.scopeAsinDataList.list.length){
				list = [...this.scopeAsinDataList.list]
			}
			else if(this.scopeAsinData){
				list = [...this.scopeAsinData]
			}
			newAsinList.map((res) => {
				let asin = {
					asin:res,
					id: res,
					type: "add asin"
				}
				list.push(asin)
			})

			if(type == 'fromAdd'){
				this.scopeAsinData = JSON.parse(JSON.stringify(list))

			}
			else{
				this.scopeAsinDataList.list = list
			}

			this.scopeAsinOptions = JSON.parse(JSON.stringify(list));
		},
		searchFromDb(searchText,data,index,type) {
			;
			console.log(this.modalValue);
			if(this.modalValue || (data && data.label)){
				this.currentSelected = index;
				if(data){
					this.scope = data.tag
				}
				if( searchText.length > 1 ){
					let storeUrl = ''
					let filterData = false
					let queryString = {
						"q": searchText,
						"resultsPerPage":null,
						"pageNumber":1,
						"sort":"",
						"doNotShowSpinner": true
					}
					switch (this.scope) {
						case 'Vendor':
							storeUrl = "getAllVendor"
							filterData = true;
							break;
						case 'Profile':
							storeUrl = "getAllBrandProfile";
							break;
						case 'CampaignGroup':
							storeUrl = "campaign/getCampaignGroupList";
							break;
						case 'Campaign':
							storeUrl = "campaign/getCampaignList";
							break;
						case 'Product':
						//	storeUrl = "product/getAllProducts";
							storeUrl = "product/getAllProductsForScope";
							break;
						default:
							break;
					}
					if(type == "fromAdd"){
						this.isLoadingInFirstSearch = true;
					}
					else{
						this.isLoading = true;
					}
					let vm = this;
					this.$store.dispatch(storeUrl, queryString).then((searchData) => {
						vm.isLoading = false
						vm.isLoadingInFirstSearch = false;
						if(searchData && !Array.isArray(searchData)){
								searchData = searchData.data
						}
						if(searchData && searchData[0] && !searchData[0].id){
							vm.scopeTrackerId = "campaign_id"
						}
						vm.showScopeOptions = searchData;
					});

					/* if(filterData && searchData && searchData.length){
						searchData = searchData.filter(v=>{
							return v.name.toLowerCase().indexOf(searchText) > -1;
						})
					} */

				} else {
					this.showScopeOptions = [];
				}
				console.log(searchText);
			}

		},
		resetFile(index){
		//	this.fileUploadedName.splice(index,1);
			this.selectedFileUrlList.splice(index,1);
			this.uploadCSVProductLoader = false;
		},
		uploadProductsList(evt){
			let file = evt.target.file || evt.target.files[0];
			let payload = {
				fileName: file.name,
				fileType:  "text/x-csv"
			}

			let vm = this;
			let fileData = "";

			this.uploadCSVProductLoader = true

			this.$store.dispatch("automation/getPresighnedURL").then((res) => {
				let data = {
					url : res.uploadUrl,
					data: file
				}
				console.log(data);
				vm.$store.dispatch("automation/uploadFile", data).then(response => {
					let payload = {
						uploadUrl: res.uploadUrl,
						downloadUrl: res.downloadUrl,
						name: file.name
					}
					vm.uploadCSVProductLoader = false;
				//	vm.fileUploadedName.push(file.name);
					if(vm.isReplaceFile!= -1){
						this.AddDeleteFile(payload, vm.addedFileUrlList, vm.isReplaceFile, "replace")
					}
					else{
						vm.selectedFileUrlList.push(payload);
					}
					console.log(response);
				});
			})

		},
		submit() {
			let payload = []
				this.scopeList.map((res) => {
					res.list.map((innerList) => {
						let innerListData = [innerList]
						var obj = {
							selectedOptions: innerListData,
							selectedKeywords: [],
							selectedType : res.tag,
							id :  this.automationId
						};
						payload.push(obj)
					})
				})
				if(this.scopeData.length){
					payload.push({
						selectedOptions: this.scopeData,
						selectedKeywords: [],
						selectedType : this.scope,
						id :  this.automationId
					})
				}
				if(this.scopeKeywordData.length){
					payload.push({
						selectedOptions: [],
						selectedKeywords: this.scopeKeywordData,
						selectedType : this.scope,
						id :  this.automationId
					})
				}



		//	this.automationId != "null" ? (payload["id"] = this.automationId) : "";
			var vm = this;
			vm.$store
				.dispatch("automation/addUpdateGuardRail", {list:payload})
				.then(response => {
					// TODO ?
					//vm.getAllAutomationsList();
					vm.toggleModal();
				});
			this.reset();
		},
		limitText(count){
			return ` and ${count} more...`
		}
	}
};
</script>

<style lang="scss">
.multiselect__content-wrapper /*, .multiselect__element */ {
  width: fit-content;
  min-width:100%
}

.associate-guardrail {
	.multiselect__tag{
		text-transform:none !important;
	}
}
.associate-guardrail {
	.multiselect__single{
		text-transform: none !important;
	}
}
.associate-guardrail {
	.multiselect__option span{
		text-transform: none !important;
	}
}

</style>
